module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"summary":{"total":"您有 {0} 筆 {1} 的","description":"未付款訂單。","hint":"（ 截至 {0} ）"},"order":{"code":"訂單編號：{0}","created_at":"下單日期：{0}","bank_account":"{0} {1} {2}","sender_name":"（匯款人：{0}）","copy_bank_account_no":"複製帳戶號碼"}}}')
  delete Component.options._Ctor
}
